import React from 'react'
import { Link } from 'react-router-dom'

export const Footer = () => {
  return (
   
 <>
 <div id='foot'>
    <footer>
<h1>MegaMart</h1>

   <div id='footer-wrapper'>

  
    <div id='footer-1'>

<p>Contant Us</p>
<p>Whatsapp</p>
<p>+234-8161645019</p>
<p>Call us</p>
<p>+234-8161645019</p>
<h6>Download App</h6>
<div id='apple-store-img-wrapper'>
<img src="asset/google-play.jpg" alt="" srcset="" />
<img src="asset/app-store.jpg" alt="" />
</div>
    </div>
    <div id='footer-2'>
<p>Most Popular Categories</p>
<ul>
    <li>Home Care</li>
    <li>Personal care</li>
    <li>Baby care</li>
    <li>staple</li>
    <li>Vegetable and fruit</li>
</ul>
    </div>

      <div id='footer-2'>
<p>Customer Services</p>
<ul>
    <li>Home Care</li>
    <li>Personal care</li>
    <li>Baby care</li>
    <li>staple</li>
    <li>Vegetable and fruit</li>
</ul>
    </div>
     </div>
     </footer>
     </div>
    </>
   
   
  )
}
